import React from 'react';
import { SecondaryButton } from '../../../Button';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { ModalSliceType, openModal } from '../../../../redux/slices/modal';
import { selectOpenedModalType } from '../../../../redux/selectors/modal';
import DuplicateReportModal from '../../ChartModals/DuplicateReportModal';
import { useChartContext } from '../../ChartContext';
import KubitTooltip from '../../../KubitTooltip';
import { assertCondition } from '../../../../utils/types';

interface Props {
  analysisId: string;
}

const DuplicateReportButton = ({ analysisId }: Props) => {
  const dispatch = useAppDispatch();

  const chartContext = useChartContext();
  assertCondition(chartContext.__typename === 'BaseChartContext');
  const {
    permissions: { entityPermissions },
  } = chartContext;

  const isDuplicateReportModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DuplicateReport, analysisId),
  );

  const handleDuplicate = () => {
    dispatch(
      openModal({
        type: ModalSliceType.DuplicateReport,
        id: analysisId,
        data: null,
      }),
    );
  };

  return (
    <>
      <KubitTooltip
        content={'Create a duplicate of this report.'}
        placement="bottom-end"
      >
        <SecondaryButton
          isOutlined={true}
          disabled={!entityPermissions.duplicateAnalysis}
          onClick={handleDuplicate}
          trackContext="reports"
          trackAction="duplicate"
        >
          Duplicate
        </SecondaryButton>
      </KubitTooltip>
      {isDuplicateReportModalOpen && (
        <DuplicateReportModal analysisId={analysisId} />
      )}
    </>
  );
};

export default DuplicateReportButton;
